import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useEmployeeCprData(employeeId?: string) {
    const { data: cprData, isLoading: isLoadingCprData } = useQuery({
        queryKey: ['employee-cpr-data', employeeId],
        gcTime: 0,
        queryFn: async () => {
            const { data } = await axios.get(
                route('v2.salary.employees.unmasked-social-security-number', {
                    employeeId,
                }),
            );
            return data;
        },
        placeholderData: [],
        enabled: !!employeeId,
    });

    return {
        cprData,
        isLoadingCprData,
    };
}
